import _ from 'lodash';

export function addOrRemoveFromArray<T>(array: T[], id: T) {
  const arrayClone = _.clone(array);
  if (_.includes(arrayClone, id)) {
    _.pull(arrayClone, id);
  } else {
    arrayClone.push(id);
  }
  return arrayClone;
}
